let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aLvnz")).then(() => parcelRequire('iVM3R'));